import { Outlet } from "react-router-dom";

function ScanLayout() {
    return <div className="container px-0 pos-relative  mh-100vh  d-flex flex-column">
        <Outlet />
    </div>
}

export default ScanLayout;
